import Vue from 'vue';
import Vuex from 'vuex';
import settings from './modules/settings';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        errors: {},
    },
    getters: {
        errors(state) {
            return state.errors;
        }
    },
    mutations: {
        SET_ERROR_DATA(state, data) {
            state.errors = Object.assign({}, data);
        },
    },
    actions: {},
    modules: {
        settings,
    },
});
